
import {lazy } from 'react';
 
 

export const routes = [
  {
    path: "/addresses",
    exact: true,
    component: lazy(() => import("./components/Addresses")),
    name: "Addresses"
  }
];

